import { ChangeDetectionStrategy, Component, output } from '@angular/core';

import { MentionType } from './mention';

@Component({
    template: `
        <span class="mention-view mention-view-inline" (click)="click.emit($event)">
            @if (mt == 'wiki') {
                <a class="bg-t-a">
                    <i class="fs-xl txt-p top2 lh08 bg-t-a vzi-book"></i>
                    {{ title }}
                </a>
            }
            @else {
                @{{ title }}
            }
        </span>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    styles: `
        .mention-view {
            vertical-align: middle;
            max-width: 250px;
            display: inline-block;
            overflow: hidden;
            &.mention-view-inline {
                max-width: inherit;
                display: inline;
                padding: 0 4px;
            }
        }
    `,
})
export class MenitonViewComponent {
    readonly click          = output<MouseEvent>();

    id?: string;
    trid?: string;
    mt?: MentionType;
    title?: string;

    setAttrs(attrs: any): void {
        [this.mt, this.id, this.trid] = attrs.id.split('|');
        this.title = attrs.label;
    }
}